'use strict';

angular.module('TurneroApp').component('coPreguntas', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'preguntasService',
        'utilsService',
        'TurneroAppConstant',
        function (preguntasService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.accion = null;
            ctrl.preguntas = [];
            ctrl.focusBuscar = false;
            ctrl.filter = false;
            ctrl.order = false;
            ctrl.exportControl = {};
            ctrl.permisos = TurneroAppConstant.Permisos;

            ctrl.$onChanges = function () {
                ctrl.grillaReload();
                ctrl.exportControl.isOpen = false
            };

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.limpiarMemoria = function () {
                ctrl.accion = null;
                //ctrl.order = false;
                ctrl.exportControl.isOpen = false
            };

            ctrl.grillaReload = function () {
                ctrl.limpiarMemoria();
                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
                }
            };

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.preguntas = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObject = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = ['Orden', 'Pregunta'];
                    for (var i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].Orden,
                            arrayObject[i].N_Opcion_Calficacion
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Preguntas',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            ctrl.getData = function (page, limit, tipo, callback) {
                ctrl.promise = preguntasService.getfiltro({
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter,
                }).$promise.then(function (res) {
                    callback(tipo, res);
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            ctrl.crear = function () {
                ctrl.limpiarMemoria();
                ctrl.accion = TurneroAppConstant.Acciones.Crear;
                ctrl.tLoad(ctrl.accion);
            };

            ctrl.modificar = function (item) {
                ctrl.limpiarMemoria();
                ctrl.accion = TurneroAppConstant.Acciones.Editar;
                ctrl.tLoad(ctrl.accion, item);
            };

            ctrl.ver = function (item) {
                ctrl.limpiarMemoria();
                ctrl.accion = TurneroAppConstant.Acciones.Ver;
                ctrl.tLoad(ctrl.accion, item);
            };

            ctrl.eliminar = function (item) {
                swal({
                    title: "Eliminar Pregunta",
                    text: "¿Desea quitar la pregunta?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!"
                }).then(function () {
                    preguntasService.delete({ 'id': item.Id_Opcion_Calificacion }).$promise.then(function (res) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "La pregunta ha sido borrada correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });

                });
            };

            ctrl.guardarOrden = function () {
                let ids = [];

                for (let i in ctrl.preguntas) {
                    ids.push(ctrl.preguntas[i].Id_Opcion_Calificacion);
                }

                preguntasService.Guardar_Orden_Preguntas({
                    'nro_Pagina': ctrl.query.page,
                    'tam_Pagina': ctrl.query.limit
                }, ids).$promise.then(function (res) {
                    sweetAlert("Ordenar", "Las Preguntas se ordenaron correctamente", "success");
                    ctrl.grillaReload();
                    ctrl.order = false;
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };

            ctrl.cancelarOrden = function () {
                ctrl.grillaReload();
                ctrl.order = false;
            };

            ctrl.onChangePagina = function () {
                if (ctrl.order) {
                    swal({
                        title: 'Atención',
                        html: '¿Desea guardar los cambios hasta el momento?',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: '#971b2f',
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function (result) {
                        ctrl.guardarOrden();
                    }, function (error) {
                        ctrl.grillaReload();
                        swal.close();
                    });
                }
                else {
                    ctrl.grillaReload();
                }
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {

                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos);
            }
            ctrl.Excel = {
                down: function () { },
            }

        }
    ],
    template: require('./preguntas.html')
});



// WEBPACK FOOTER //
// ./app/components/preguntas/preguntasComponent.js